import styled from 'styled-components';

import { OnboardingPageBackgroundBox } from 'components/common/OnboardingPageWrapper/OnboardingPageWrapper.style';
import LoginLarge from '../../assets/images/login/large.png';
import LoginMedium from '../../assets/images/login/medium.png';
import LoginSmall from '../../assets/images/login/sm.png';
import LoginXL from '../../assets/images/login/xl.png';

export const LoginPageWrapper = styled(OnboardingPageBackgroundBox)`
    background-image: url(${LoginXL});
    background-size: 82%;
    background-position: bottom right;
    min-height: 80rem;
    @media (max-width: ${({ theme }) => theme.breakpoints.L.max}px) {
        background-image: url(${LoginLarge});
        background-size: 85%;
        background-position: bottom right;
    }
    @media (max-width: ${({ theme }) => theme.breakpoints.M.max}px) {
        background-image: url(${LoginMedium});
        padding-bottom: 80%;
    }
    @media (max-width: ${({ theme }) => theme.breakpoints.S.max}px) {
        background-image: url(${LoginSmall});
        padding-bottom: 110%;
    }
`;
